import React, { useState, useEffect, useCallback, memo } from 'react';
import { FaEllipsisV } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { deleteEmail } from '../../services/emailsService';
import apiClient, { getCurrentUserId } from '../../services/apiClient';

function Email() {
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [newTemplate, setNewTemplate] = useState({ title: '', content: '' });
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient.get(`/getemail-templates/${getCurrentUserId()}`)
      .then(response => setEmailTemplates(response.data))
      .catch(error => console.error(error));
  }, []);

  const handleEdit = useCallback((emailId) => {
    navigate(`/edit-email-template/${emailId}`);
  }, [navigate]);

  const handleDelete = async (emailId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
          customClass: {
        popup: 'swal-top-zindex'
      }
      });

      if (result.isConfirmed) {
        await deleteEmail(emailId);
        setEmailTemplates(emailTemplates.filter((email) => email.id !== emailId));
        Swal.fire("Deleted!", "Your email has been deleted.", "success");
        //handleProductContentChange("Untitled Item");
      }
    } catch (error) {
      console.error(`Failed to delete email with ID ${emailId}:`, error);
      Swal.fire("Error", getErrorMessage(error, "Failed to delete email."), "error");
    }
  };
  const createTemplate = () => {
    apiClient.post(`/email-templates`, newTemplate)
      .then(response => {
        setEmailTemplates([...emailTemplates, response.data]);
        setNewTemplate({ title: '', content: '' });
      })
      .catch(error => console.error(error));
  };

  const updateTemplate = (id, updatedTemplate) => {
    apiClient.put(`/email-templates/${id}`, updatedTemplate)
      .then(response => {
        const updatedTemplates = emailTemplates.map(template => 
          template.id === id ? response.data : template
        );
        setEmailTemplates(updatedTemplates);
      })
      .catch(error => console.error(error));
  };

  const toggleMenu = (email) => {
    setSelectedEmail(email);
    setMenuVisible(!menuVisible);
  };

  return (
    <div>
      <div className='container-fluid'>
        {/* <div>Templates &gt; Emails</div> */}
      </div>

      <div className='container-fluid p-lg-5 p-md-5 p-3'>
        <div className='row g-lg-5 g-md-5 g-3'>
          <div className='col-sm-12 col-md-12 col-xl-12'>
            <div className='mb-4'>
              <h3 className='mb-1'>Emails</h3>
              <p>
                Do you often find yourself repeating the same information to clients? Save time and maintain consistency by creating email templates.<br />  With templates, you can quickly craft professional messages in any language you commonly use, ensuring clear and efficient communication with your clients. 
              </p>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4 product-items'>
            <div className='h-100 bg-white rounded p-3 shadow-sm'>
              <Link
                to='/create-email-template'
                id=''
                className='h-100 d-flex align-items-center justify-content-center px-2 py-5 p-urls'
                style={{ border: "1px dashed #534dbb" }}>
                <div className='mb-4 text-center'>
                  <i
                    className='fa-solid fa-plus'
                    style={{ fontSize: "70px" }}></i>
                  <h6 className='mb-0 fw-bold text-uppercase'>
                    CREATE A EMAIL TEMPLATE
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          {emailTemplates.map(template => (
            <div key={template.id} className='col-sm-12 col-md-6 col-xl-4 product-items'>

              
              <div className='h-100 bg-white d-flex align-items-center justify-content-center rounded p-4 shadow-sm position-relative product-items2' onClick={ () =>  handleEdit(template.id)}>
                
                
                <div className='three-dot-btn' >
                  
                  <div className='position-absolute top-0 end-0 me-3 mt-2'>
                    <button className='border-0 bg-transparent ' type='button'>
                      <div id='p-dot' style={{ position: "relative", zIndex: 10000 }} onMouseEnter={() => toggleMenu(template)}
  onMouseLeave={() => toggleMenu(null)} >
                      <FaEllipsisV
                        
                        style={{ cursor: "pointer" }}
                      />
                      {menuVisible && selectedEmail === template && (
                        <div
                          className='position-absolute bg-white shadow-sm rounded'
                          style={{
                            top: "20px",
                            right: "0",
                            zIndex: "10",
                          }}>
                          <button
                            className='dropdown-item'
                            onClick={() => handleEdit(template.id)}>
                            Edit
                          </button>
                          <button
                            className='dropdown-item'
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(template.id)}
                              }>
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                    </button>
                  </div>

                  <p style={{ fontSize: 12 }}>
                    Created at{" "}
                    {new Date(template.created_at).toLocaleDateString()}
                  </p>
                  <div className='text-center edit-btn'>
                    <button className='border-0 bg-transparent' type='button'>
                      <i className='fa-solid fa-file-signature'></i>
                    </button>
                    <p className='basic-photo'>
                      {template.title.toUpperCase()}
                    </p>
                  </div>
                  
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(Email);
